var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.736 10.662c-.178.417-.656.69-1.04.903-.503.273-1.014.435-1.585.435-.793 0-1.508-.325-2.233-.588a7.92 7.92 0 0 1-1.492-.708c-1.449-.894-3.196-2.641-4.09-4.09a7.98 7.98 0 0 1-.708-1.492C.324 4.398 0 3.682 0 2.89c0-.57.162-1.082.435-1.585C.648.921.92.443 1.338.264 1.62.136 2.216 0 2.523 0c.06 0 .12 0 .179.026.179.06.366.477.452.647.272.486.537.98.818 1.458.136.221.392.494.392.759 0 .52-1.543 1.278-1.543 1.738 0 .23.214.529.333.733.861 1.55 1.934 2.625 3.487 3.486.203.12.502.332.732.332.46 0 1.22-1.541 1.739-1.541.264 0 .537.254.76.391.476.28.971.547 1.456.818.17.086.588.273.648.451.024.06.024.12.024.18 0 .306-.136.903-.264 1.184Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePhone);
export default __webpack_public_path__ + "static/media/white-phone.964327c56851e6e80bfe3f5d084dcd99.svg";
export { ForwardRef as ReactComponent };